<template>
  <vue-multiselect-ajax
      :key="`${_uid}-products`"
      :custom-label="customLabel"
      :disabled="disabled"
      :name="name || 'product'"
      :params="{ ...params }"
      :placeholder="$t('Select {something}', { something: $t('products.singular') })"
      :required="required"
      :url="`/products`"
      :value="value"
      v-bind="$attrs"
      v-on="$listeners"
  >
    <template v-slot:option="{ option }">
      <slot name="option" v-bind="{ option }"></slot>
    </template>
  </vue-multiselect-ajax>
</template>

<script>
import VueMultiselectAjax from "@/components/inputs/vue-multiselect-ajax";

export default {
  name: 'product-select-ajax',
  components: {
    VueMultiselectAjax,
  },
  props: {
    name: {
      type: String,
      default: undefined
    },
    value: {
      type: Number,
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return {}
      }
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      }
    },
    customLabel: {
      type: Function,
      default({name}) {
        return name
      }
    },
    loaded: {
      type: Function,
      default() {
        return () => {
        };
      }
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event)
    },
    clearAll() {
      this.$emit('input', undefined)
    },
  }
}
</script>

<style scoped>

</style>